import { render } from "./NavigationButton.vue?vue&type=template&id=77fc6ef8&ts=true"
import script from "./NavigationButton.vue?vue&type=script&lang=ts"
export * from "./NavigationButton.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__